module.exports = __webpack_public_path__ + "img/5.7fbc4114.jpg";